import React, { Component } from "react";
import SwipeableViews from "react-swipeable-views";

interface VirtualizedSwipeableViewsProps
  extends React.HTMLAttributes<HTMLElement> {
  index: number;
  onChangeIndex?: (index: number, previousIndex: number) => void;
  onChangeDone?: (index: number) => void;
  overscanSlideAfter: number;
  overscanSlideBefore: number;
  slideCount?: number;
  slideRenderer: (index: number) => Element;
  containerStyle?: React.CSSProperties;
}

interface VirtualizedSwipeableViewsState {
  index: number;
  indexContainer: number;
  indexStart: number;
  indexStop: number;
}

export default class VirtualizedSwipeableViews extends Component<
  VirtualizedSwipeableViewsProps,
  VirtualizedSwipeableViewsState
> {
  timer?: number;

  componentWillMount(): void {
    this.setState({
      index: this.props.index || 0,
      indexStart: 0,
      indexStop: this.props.overscanSlideAfter,
    });
  }

  componentWillUnmount(): void {
    clearInterval(this.timer);
  }

  componentWillReceiveProps(nextProps: VirtualizedSwipeableViewsProps) {
    const { index } = nextProps;

    if (index !== this.props.index) {
      const indexDiff = index - this.props.index;
      this.setIndex(index, this.state.indexContainer + indexDiff, indexDiff);
    }
  }

  setIndex(index: number, indexContainer: number, indexDiff: number) {
    const nextState = {
      index,
      indexContainer,
      indexStart: this.state.indexStart,
      indexStop: this.state.indexStop,
    };

    // We are going forward, let's render one more slide ahead.
    if (
      indexDiff > 0 &&
      (!this.props.slideCount ||
        nextState.indexStop < this.props.slideCount - 1)
    ) {
      nextState.indexStop += 1;
    }

    // Extend the bounds if needed.
    if (index > nextState.indexStop) {
      nextState.indexStop = index;
    }

    const beforeAhead = nextState.indexStart - index;

    // Extend the bounds if needed.
    if (beforeAhead > 0) {
      nextState.indexContainer += beforeAhead;
      nextState.indexStart -= beforeAhead;
    }

    this.setState(nextState);
  }

  handleChangeIndex = (indexContainer: number, indexLatest: number) => {
    const { slideCount, onChangeIndex } = this.props;

    const indexDiff = indexContainer - indexLatest;
    let index = this.state.index + indexDiff;

    if (slideCount) {
      index = index % slideCount;
    }

    // Is uncontrolled
    this.setIndex(index, indexContainer, indexDiff);

    if (onChangeIndex) {
      onChangeIndex(index, this.state.index);
    }
  };

  handleTransitionEnd = () => {
    if (this.props.onChangeDone) {
      this.props.onChangeDone(this.state.index);
    }
  };

  render() {
    const {
      children,
      index,
      onChangeIndex,
      onTransitionEnd,
      overscanSlideAfter,
      overscanSlideBefore,
      slideCount,
      slideRenderer,
      containerStyle,
      onChangeDone,
      ...other
    } = this.props;
    const { indexStart, indexStop } = this.state;

    let slides = new Array<Node>();
    for (
      let slideIndex = indexStart;
      slideIndex <= indexStop;
      slideIndex += 1
    ) {
      slides.push(this.props.slideRenderer(slideIndex));
    }

    return (
      <SwipeableViews
        index={this.state.indexContainer}
        onChangeIndex={this.handleChangeIndex}
        onTransitionEnd={this.handleTransitionEnd}
        containerStyle={containerStyle}
        {...other}
      >
        {slides}
      </SwipeableViews>
    );
  }
}
